const WORDS = ["Retail POS", "E-commerce gateways", "Mobile tap-to-pay", "Payroll", "Free statement reviews", "Transparent pricing"];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <section className="marquee-wrap relative bg-[var(--ink)] text-white py-8 sm:py-10 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track flex items-center">
        {row.map((w, i) => (
          <span key={i} className="flex items-center font-display text-4xl sm:text-6xl font-light tracking-tight whitespace-nowrap">
            <span className="px-8 sm:px-12">{w}</span>
            <span className="font-serif-i text-[var(--mint)] text-3xl sm:text-5xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};
